import React from 'react'
import BGBlock from './BGBlock'
import { AiOutlineTag } from "@react-icons/all-files/ai/AiOutlineTag";
import { AiOutlinePercentage } from "@react-icons/all-files/ai/AiOutlinePercentage";
import PicCont from './PicCont';
import trust from '../public/Pictures/trust.png'
import percentage from '../public/Pictures/percentage.png'
import bill from '../public/Pictures/bill.png'
import analytics from '../public/Pictures/analytics.png'
import white from '../public/Pictures/model4_header.jpg'
import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";

const B2BModelFour = ({}) => {

  return <section className='b2bModel' id='model4' >
    <BGBlock src={white} >
        <div className="row">
            <AiOutlinePercentage /> <h2>Referral Discount Program</h2>
        </div>
    </BGBlock>
    <div className="partOne">
        <strong className="bTitle">What is it?</strong>
        <p>
        This model is designed to <strong>automatically provide a discount</strong> on AV simply for referring clients to us. <br/><br/>
        Venue Partner featured page. Dedicated account manager, customized AV packages.<br/><br/>
        New relevant source of <strong>highly qualified leads</strong>.
        </p>
    </div>
    <div className="partTwo">
        <strong className="bTitle">How does it work?</strong>
        <div className="row">
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={trust}  />
                <strong className="cTitle bold">Two way partnership</strong>
                </div>
            <div className="divP">
                <p>
                The venue registers on our platform as part of our <strong>Venue Partners</strong>. When a client books an AV service from us in that venue (referred or not), our partner&apos;s client <strong>automatically gets a discount.</strong> <br/><br/>
                 Our partners are also listed on our Venue Partnerships section and benefit from our <strong>high qualified leads</strong>.
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={bill}  />
                <strong className="cTitle bold">Automatic Discount</strong>
                </div>
            <div className="divP second">
                <p>
            Effortless way for our partners to offer perks to their client. Our partners just have to direct the clients to Miami Sound Rental to benefit of <strong>exclusive discounts</strong> on custom made packages. <br/><br/>
             Partners have the ability to switch to a commission based model at any moment from their Partner Portal.
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={analytics}  />
                <strong className="cTitle bold">Customized AV Solutions </strong>
                </div>
            <div className="divP">
            <p>
                Tailored <strong>advisory service</strong>, we deploy our experts to the venue to craft <strong>customized packages for each room sizes and types</strong>. Our assessment provides a set of tailor made packages (6-10) that are delivered on an unbranded booklet with QR codes that directly link with the Package Page. All the packages are shown in the Venue Partnerships Page.<br /><br />
We provide our <strong>techology platform and digital tools</strong> at the service of the partner: Online setup builder to edit or create new packages, equipment inventory updated in real time, quick quoting service, etc. 
                </p>
                </div>
            </div>
            <div className="col">
            <div className="header">
                <PicCont width={512} height={512} src={percentage}  />
                <strong className="cTitle bold">Tiered Discount Schedule</strong>
                </div>
            <div className="divP last">
            <p>
                Progressive discount schedule based on volume of sales for the previous month:<br/><br/>
                <div className='discountRow'><strong>First Month:</strong><span className='discount'>20% Discount</span> </div><br/>
                 
                <div className='discountRow headRow'><strong>After fist month:</strong><span className='discount'>Discount</span> </div><br/>
                <div className='discountRow'><span>Less than <strong>$10,000</strong> in sales:</span><span className='discount'>10%</span> </div>
                <div className='discountRow'><span>Between <strong>$10,000</strong> and <strong>$30,000</strong> in sales:</span><span className='discount'>20%</span> </div>
                <div className='discountRow'><span>More than <strong>$30,000</strong> in sales:</span><span className='discount'>30%</span> </div><br/>
                <strong>Discounts are directly applied to the venue</strong> in each service.
                </p>
                </div>
            </div>
        </div>
    </div>
    <div className="partThree">
        <strong className="bTitle">How does it benefit your business?</strong>
        <div className='row'>
            <div className="point">
                <strong className='pointTitle'><IoIosArrowForward /> Easy way to offer perks to your clients when they book with you</strong>
                <p>
                This model allows the partner to include as a value proposition for its sales process a discount with the top rated AV service in South Florida. 
                </p>
            </div>
            <div className="point ">
                <strong className='pointTitle'><IoIosArrowForward /> New source of high volume of qualified traffic and leads</strong>
                <p>
                Benefit of being part of our Venue Partnerships section. As <strong>digital sales leaders in AV services in South Florida</strong>, we have the maximum coverage of internet searches related to audiovisual material for event production. Our platform has over 3,000 monthly visits from qualified leads by interest and geographic location.
                </p>
            </div>
            <div className="point">
                <strong className='pointTitle'><IoIosArrowForward /> Reliability in service: Stress-free referrals </strong>
                <p>
                Thanks to our data-driven service planning and delivery, we ensure flawless execution. We are the top-rated AV provider in South Florida. <strong>Partners can be confident that the customers they refer to us will receive the best service</strong>. 
                </p>
            </div>
            <div className="point last">
                <strong className='pointTitle'><IoIosArrowForward /> Real-time information of all aspects related to their client’s orders. </strong>
                <p>
                Thanks to our technology, and connected operations, we inform you in real time of any changes related to your client's event (schedule changes, unforeseen events, etc.).
                </p>
            </div>
      

      
        </div>
    </div>

  </section>
}

export default B2BModelFour